import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ButtonModule, ModalModule, UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, FinFormsModule, PipesModule } from '@fcom/common';
import { GtmModule } from '@fcom/common/gtm';
import { CommonBookingComponentsModule } from '@fcom/common-booking/components';
import { DataCloudModule } from '@fcom/common/datacloud';

import { BookingNotificationModule } from '../../components/booking-notification/booking-notification.module';
import { BookingCommonModule } from '../common/booking-common.module';
import { KoreaNotificationComponent } from './components/korea-notification.component';
import { PaxDetailsFormComponent } from './components/pax-details-form.component';
import { PaxDetailsComponent } from './components/pax-details.component';
import { BookingPaxDetailsRouteComponent } from './routes/booking-pax-details-route.component';
import { PaxDetailsGuard } from './services/pax-details.guard';
import { PaxAncillariesComponent } from './components/pax-ancillaries/pax-ancillaries.component';
import { UpgradePromotionComponent } from './components/upgrade-promotion/upgrade-promotion.component';
import { PaxAncillaryProductComponent } from './components/pax-ancillary-product/pax-ancillary-product.component';
import { UpgradePromotionModalComponent } from './components/upgrade-promotion/upgrade-promotion-modal.component';
import { PaxDetailsMarketingConsentComponent } from './components/pax-details-marketing-consent/pax-details-marketing-consent.component';
import { PaxShortcutToPayComponent } from './components/pax-shortcut-to-pay/pax-shortcut-to-pay.component';
import { KidsInBusinessNotificationComponent } from './components/kids-in-business-notification/kids-in-business-notification.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    BookingCommonModule,
    FormsModule,
    FinFormsModule,
    GtmModule,
    DataCloudModule,
    CmsModule,
    PipesModule,
    DirectiveModule,
    UiTranslateModule,
    ButtonModule,
    ModalModule,
    CommonBookingComponentsModule,
    UiComponentsModule,
    BookingNotificationModule,
  ],
  declarations: [
    BookingPaxDetailsRouteComponent,
    PaxDetailsComponent,
    PaxDetailsFormComponent,
    PaxDetailsMarketingConsentComponent,
    KoreaNotificationComponent,
    PaxAncillariesComponent,
    PaxAncillaryProductComponent,
    PaxShortcutToPayComponent,
    UpgradePromotionComponent,
    UpgradePromotionModalComponent,
    KidsInBusinessNotificationComponent,
  ],
  exports: [BookingPaxDetailsRouteComponent, PaxAncillaryProductComponent],
  providers: [PaxDetailsGuard],
})
export class PaxDetailsModule {}
